/** Class responsible for scene subject management;
 * - constructor must take a Scene object;
 * - must have a public update() method.
 */

import TrioMesh from './TrioMesh';
import PropMesh from './PropMesh';
import TrioSpheres from './TrioSpheres';

export default class GeoSpawner
{
    constructor(scene, terrainSize) 
    {
        this.scene = scene;
        this.terrainSize = terrainSize;
        this.geos = [];
        
        this.geos.push(new TrioMesh(this.scene, this.terrainSize));
        this.geos.push(new TrioSpheres(this.scene, this.terrainSize));
        this.geos.push(new PropMesh(this.scene, this.terrainSize));
        this.mouseDown = false;
    }

    update(time) 
    {	
        for(let i=0; i<this.geos.length; i++) 
        {
            this.geos[i].update(time);
		}

        if(this.mouseDown) 
        {
			this.onMouseDown();
        }

		this.mouseDown = false;
    };
    
    onMouseDown(e)
    {
        for(let i=0; i<this.geos.length; i++) 
        {
            this.geos[i].onAction(e);
		}
        this.mouseDown = true; 
    };
}